<template>
  <div
    v-if="showLoadingState || $store.getters.getAcademyLoadingSubmenu"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="academyUserProfile"
    class="m-edition-academy-users-profile"
  >
    <div class="m-card-primary profile-info">
      <div class="display-flex-row-center profile-info-user">
        <AtomAvatarSecondary
          avatar-class="xlarge profile-info-user-avatar"
          :user-image="perfil.usuario.avatar"
        />
        <span class="display-flex-column font-weight-light justify-content-center profile-info-user-email">
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.razon_social"
            class="font-size-large"
          >
            <b>{{ perfil.usuario.persona.razon_social }}</b>
          </span>
          <span :class="getUserGlobalState()">
            {{ perfil.usuario.email }}
          </span>
          <span class="font-size-small text-color-black-55">
            {{ $t('mEditionAcademyUsersProfile.messages.activeSince') }}
            <span class="text-transform-capitalize">
              {{ $moment.parseZone(perfil.actores[0].fecha_alta).format('D MMMM YYYY') }}
            </span>
          </span>
        </span>
      </div>

      <div class="profile-info-persona">
        <p class="display-flex-row">
          <span class="margin-right-small profile-info-persona-icon">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.domicilio"
            class="profile-info-persona-text"
          >
           <span> {{ perfil.usuario.persona.domicilio.provincia.pais.nombre }} </span>
           <span>, {{ perfil.usuario.persona.domicilio.provincia.nombre }} </span>
           <span v-if="perfil.usuario.persona.domicilio.localidad">
              , {{ perfil.usuario.persona.domicilio.localidad }}
           </span>
           <span v-if="perfil.usuario.persona.domicilio.codigo_postal">
              , {{ perfil.usuario.persona.domicilio.codigo_postal }}
           </span>
           <span v-if="perfil.usuario.persona.domicilio.linea1">
              , {{ perfil.usuario.persona.domicilio.linea1 }} </span>
           <span v-if="perfil.usuario.persona.domicilio.linea2">
              {{ perfil.usuario.persona.domicilio.linea2 }} </span>
          </span>
          <span
            v-else
            class="profile-info-persona-text"
          >
            {{ `(${$t('mEditionAcademyUsersProfile.messages.noLocation')})` }}
          </span>
        </p>

        <p class="display-flex-row">
          <span class="margin-right-small profile-info-persona-icon">
            <i class="fas fa-balance-scale"></i>
          </span>
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.documento"
            class="profile-info-persona-text"
          >
            {{ $filters.getPersonValue(+perfil.usuario.persona.fisica, 'name') }}
          <span v-if="perfil.usuario.persona.documento && perfil.usuario.persona.documento.tipo.id_documento_tipo !== 1 &&  perfil.usuario.persona.documento.tipo.nombre !== 'ID' &&  perfil.usuario.persona.documento.numero">
            &bull;
            {{ perfil.usuario.persona.documento.tipo.nombre }}
            {{ perfil.usuario.persona.documento.numero }}
          </span>
          </span>
          <span
            v-else
            class="profile-info-persona-text"
          >
            {{ `(${$t('mEditionAcademyUsersProfile.messages.noLegal')})` }}
          </span>
        </p>

        <p class="display-flex-row">
          <span class="margin-right-small profile-info-persona-icon">
            <i class="fas fa-mobile-alt"></i>
          </span>
          <span
            v-if="perfil.usuario.persona"
            class="profile-info-persona-text"
          >
            {{ $t('mEditionAcademyUsersProfile.messages.phone') }}
            {{ perfil.usuario.persona.telefono || `(${$t('mEditionAcademyUsersProfile.messages.noNumber')})` }}
            &bull;
            {{ $t('mEditionAcademyUsersProfile.messages.mobile') }}
            {{ perfil.usuario.persona.movil || `(${$t('mEditionAcademyUsersProfile.messages.noNumber')})` }}
          </span>
          <span
            v-else
            class="profile-info-persona-text"
          >
            {{ `(${$t('mEditionAcademyUsersProfile.messages.noContact')})` }}
          </span>
        </p>
      </div>

      <div class="profile-info-roles">
        <h4>{{ $t('mEditionAcademyUsersProfile.title') }}</h4>
        <ul class="a-list-clean margin-bottom-zero width-100-pr">
          <li
            v-for="(actor, index) in perfil.actores"
            :key="index"
            class="display-flex-row-center font-weight-light margin-bottom-medium"
          >
            <span>
              {{ $filters.getActorValue(actor.tipo, 'name') }}
            </span>
            <span class="margin-left-auto">
              <AtomTogglePrimary
                v-model="actor.habilitado"
                :disabled="requests.updateAcademiaActorEstado.isRequested"
                :element-id="actor.id"
                method="updateAcademiaActorEstado"
                name="habilitado"
                :show-loading="requests.updateAcademiaActorEstado.isRequested &&
                  requests.updateAcademiaActorEstado.itemLoading === actor.id"
                sliderClass="a-toggle-slider-academy-primary"
                type="checkbox"
                @updateAcademiaActorEstado="updateAcademiaActorEstado"
                :ref="`toggle_${actor.id}`"
              />
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyUsersProfileAccount',

  data () {
    return {
      isManualUpdate: false,

      perfil: {},

      requests: {
        updateAcademiaActorEstado: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true
    }
  },

  created () {
    this.readAcademiaPerfilActor()
  },

  methods: {
    getUserGlobalState () {
      if (this.perfil.actores.find(actor => actor.habilitado === 1)) {
        return 'font-weight-bold text-color-success'
      } else {
        return 'font-weight-bold text-color-danger'
      }
    },

    readAcademiaRecursosUsados () {
      this.$license.readAcademiaRecursosUsados()
    },

    readAcademiaPerfilActor () {
      // TODO: Modificar nombre de endpoint desde BE y FE
      this.$services.read('academia', 'readAcademiaPerfilActor', {}, [this.$store.getters.getAcademyData.id, this.$route.params.id])
        .then(response => {
          this.perfil = Object.assign({}, response.data)
          this.perfil.actores.sort((a, b) => {
            return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
          })
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    updateAcademiaActorEstado (element) {
      if (this.isManualUpdate) {
        this.perfil.actores.find(actor => actor.id === element.id).habilitado = 0
        this.isManualUpdate = false;
        return;
      }

      if (!this.requests.updateAcademiaActorEstado.isRequested) {
        let actorTipo = ''
        switch (this.perfil.actores.find(actor => actor.id === element.id).tipo) {
          case 0:
            actorTipo = 'alumnos'
            break
          case 1:
            actorTipo = 'profesores'
            break
          case 2:
            actorTipo = 'administradores'
            break
          case 7:
            actorTipo = 'instructores'
            break
        }

        this.requests.updateAcademiaActorEstado.isRequested = true
        this.requests.updateAcademiaActorEstado.itemLoading = element.id
        if (this.$license.isMaximumReached(actorTipo) && element.state) {
          this.$modal.showModal('MoleculeLicenseModalUpgrade', actorTipo)
          this.perfil.actores.find(actor => actor.id === element.id).habilitado = 1
          this.isManualUpdate = true;
          this.$nextTick(() => {
            this.$refs[`toggle_${element.id}`][0].updateValue({ target: { checked: Boolean(1) } });
          });
          this.requests.updateAcademiaActorEstado.isRequested = false
        } else {
          this.$services.update('academia', 'updateAcademiaActorEstado', { estado: element.state }, [this.$store.getters.getAcademyData.id, element.id])
            .then(response => {
              this.readAcademiaRecursosUsados()
              this.$alerts.pushAlert('mEditionAcademyUsersProfile', 'updateAcademiaActorEstado', response.data.habilitado ? 'activationSuccess' : 'deactivationSuccess')
              this.requests.updateAcademiaActorEstado.isRequested = false
            })
            .catch(error => {
              console.log(error)
              this.readAcademiaRecursosUsados()
              this.$alerts.pushAlert('mEditionAcademyUsersProfile', 'updateAcademiaActorEstado', 'error', 'a-alert-danger')
              this.perfil.actores.find(actor => actor.id === element.id).habilitado = !element.state
              this.requests.updateAcademiaActorEstado.isRequested = false
            })
        }
      }
    }
  }
}
</script>
